import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FacebookPlayer, IGTVPlayer, DLYouTubePlayer } from '../';
import style from './styles/style.module.css';


class FlexPlayer extends Component {
    determinePlayer = ( url ) => {
        if( FacebookPlayer.canPlay( url ) ) {
            return FacebookPlayer;
        }
        if( DLYouTubePlayer.canPlay( url ) ) {
            return DLYouTubePlayer;
        }
        if( IGTVPlayer.canPlay( url ) ) {
            return IGTVPlayer;
        }
        this.props.onError( { type: 'noplayermatch', error: 'Couldn\'t match a player to that url' } );
        return null;
    }


    render() {
        const Player = this.determinePlayer( this.props.url );

        const props = { ...this.props };

        return (
            <div className={ style.flexPlayer }>
                { Player &&
                    <Player { ...props } />
                }
            </div>
        );
    }
}
FlexPlayer.propTypes = {
    url: PropTypes.string.isRequired,
};
FlexPlayer.defaultProps = {
    onError: () => {},
};

const mapStateToProps = ( state ) => {
    return {
        screenSize: state.screenSize,
        videoPlaying: state.vars.videoPlaying,
    };
};

export default connect( mapStateToProps )( FlexPlayer );
